export default __webpack_public_path__ + "static/media/pyramid.c5174d50.png";